import HomePage from "@/components/home/HomePage";

export default function HomeRoute() {
  return <HomePage />;
}
